import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function collectionsReducer(state = initialState.collections, action) {
	switch(action.type) {
		case types.LOAD_COLLECTIONS_SUCCESS:
			//debugger;
			return action.libraries;

		default:
			return state;
	}
}


/** WEBPACK FOOTER **
 ** ./src/reducers/collectionsReducer.js
 **/